import React from 'react'
import MUIButtonBase, { ButtonBaseProps } from '@mui/material/ButtonBase'
import omit from 'lodash/omit'

export type Props = ButtonBaseProps & {
  buttonRef?: React.Ref<HTMLButtonElement | null>
}

const legacyOmit = [
  'raised',
  'large',
  'showBackgroundColorWithoutHover',
  'bordered',
  'showControls',
  'isActive',
] as const

const ButtonBase = React.forwardRef<HTMLButtonElement, Props>(
  ({ children, className, buttonRef, disabled, ...props }, ref) => (
    <MUIButtonBase
      {...(omit(props, legacyOmit as unknown as string[]) as ButtonBaseProps)}
      className={className}
      disabled={disabled}
      ref={(buttonRef ?? ref) as any}
    >
      {children}
    </MUIButtonBase>
  ),
)

ButtonBase.displayName = 'ButtonBase'

export default ButtonBase
